import authToken from '~/mixins/authToken';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import PersonaSection from '~/components/members-area/PersonaSection.vue';
export default {
  name: 'Persona',
  components: {
    LoadingOverlay,
    PersonaSection
  },
  mixins: [authToken],
  layout: 'no-header',
  data() {
    return {
      processing: true,
      personaLoading: true,
      memberProfile: null
    };
  },
  async mounted() {
    try {
      this.memberProfile = await this.$axios.$get('/api/members/profile');
      this.processing = false;
    } catch (error) {
      console.error('[persona] [standalone] error fetching profile', error);
      this.onError(error);
    }
  },
  methods: {
    dismiss() {
      this.$router.push('/app/dismiss');
    },
    async onPersonaComplete() {
      this.processing = true;
      try {
        await this.$axios.$get('/api/members/update-signup-cache-kyc');
        this.dismiss();
      } catch (error) {
        console.error('[persona] [standalone] error updating signup cache', error);
        this.onError(error);
      }
    },
    onError(error) {
      this.$sentry.captureException(error);
      if (error.response && error.response.status === 401) {
        return this.$router.push('/members/login?redirect=%2Fmembers%2Fpersona');
      }
      throw error;
    }
  }
};